var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlatColorIconsCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 4.125C9.69375 4.125 4.125 9.69375 4.125 16.5C4.125 23.3062 9.69375 28.875 16.5 28.875C23.3062 28.875 28.875 23.3062 28.875 16.5C28.875 9.69375 23.3062 4.125 16.5 4.125ZM16.5 6.875C18.6313 6.875 20.625 7.63125 22.275 8.8L8.8 22.275C7.63125 20.625 6.875 18.6313 6.875 16.5C6.875 11.2063 11.2063 6.875 16.5 6.875ZM16.5 26.125C14.3687 26.125 12.375 25.3687 10.725 24.2L24.2 10.725C25.3687 12.375 26.125 14.3687 26.125 16.5C26.125 21.7938 21.7938 26.125 16.5 26.125Z",
    fill: "#D50000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlatColorIconsCancel);
export default __webpack_public_path__ + "static/media/flat-color-icons_cancel.bed0ee613fd93b20c49cbcceb4a972f5.svg";
export { ForwardRef as ReactComponent };